// В этом файле перечисляются константы ключей, используемых для хранения
// данных в localStorage

export const LOCAL_STORAGE_AUTH = 'auth';
